import dayjs from 'dayjs'

export const formatDatetime = (startTime, endTime) => {
  const displayedStartTime = formatStartTime(dayjs(startTime), dayjs(endTime))
  const displayedEndTime = formatEndTime(dayjs(endTime))
  return `${displayedStartTime} ~ ${displayedEndTime}`
}
const formatStartTime = (startTime, endTime) => {
  return endTime > endTime.startOf('day').add(10, 'hours') ||
    startTime >= startTime.startOf('day').add(10, 'hours')
    ? startTime.format('HH:mm')
    : startTime.format('h34:mm')
}
const formatEndTime = (endTime) => {
  return endTime > endTime.startOf('day').add(10, 'hours')
    ? endTime.format('HH:mm')
    : endTime.format('h34:mm')
}
